/* eslint-disable no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { countryData } from "../data/countrydata";
import { AnimatePresence, motion } from "framer-motion";
import { RingingPhone } from "./svgs/RingingPhone";
import "./styles.css";
import { API_URL } from "../Store";
import { HeroSVg2 } from "./HeroSVg2";
import { IoAddOutline } from "react-icons/io5";
import ReCAPTCHA from "react-google-recaptcha";
import { RiCustomerService2Fill } from "react-icons/ri";
import { BsBuildings } from "react-icons/bs";
import { LuNotebookText } from "react-icons/lu";
import { CiPhone } from "react-icons/ci";
import { GoPackageDependents } from "react-icons/go";

export const Hero = () => {
  const [inforModal, setInfoModal] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(countryData[0]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [verificationCode, setVerificationCode] = useState("");
  const [selectedBot, setSelectedBot] = useState("");

  const handleSelectChange = (event) => {
    const selectedDialCode = event.target.value;
    const country = countryData.find(
      (item) => item.dial_code === selectedDialCode
    );
    setSelectedCountry(country);
  };

  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  const handleMakeCall = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleVerificationCodeChange = (e) => {
    setVerificationCode(e.target.value);
  };

  const handleCloseModal = () => {
    setInfoModal(false);
    setCurrentStep(1);
  };

  const [formData, setFormData] = useState({
    // name: "",
    phoneNumber: "",
    // email: "",
    country: "",
  });

  const [errorMessage, setErrorMessage] = useState("");

  const [capValue, setCapValue] = useState(null);

  useEffect(() => {
    if (capValue) {
      const timer = setTimeout(() => {
        setCapValue(null);
      }, 60000);

      return () => clearTimeout(timer);
    }
  }, [capValue]);

  const handleApiSubmit = async () => {
    if (!formData.phoneNumber) {
      setErrorMessage("Phone Number is required.");
      return;
    }

    if (selectedBot === "") {
      setErrorMessage("Please select an assistant");
      return;
    }

    if (capValue === null) {
      setErrorMessage("Please fill Out Captcha.");
      return;
    }

    setErrorMessage("");

    try {
      const response = await fetch(`${API_URL}save-new-user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          selectedBot,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to submit data");
      }

      console.log("Data submitted successfully");
      setCurrentStep(2);
      setFormData({
        name: "",
        phoneNumber: "",
        email: "",
        country: "",
      });
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  useEffect(() => {
    if (errorMessage) {
      const timeout = setTimeout(() => {
        setErrorMessage("");
      }, 2000);
      return () => clearTimeout(timeout);
    }
  }, [errorMessage]);

  useEffect(() => {
    if (currentStep === 2) {
      const timer = setTimeout(() => {
        setInfoModal(false);
        setCurrentStep(1);
      }, 20000);
      return () => clearTimeout(timer);
    }
  }, [currentStep]);

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, delay: i * 0.3 },
    }),
  };


  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null); // <== Ref for click outside
  const [formData2, setFormData2] = useState({
    country: null, // Full country object for UI
  });


  const handleSelect = (country) => {
    setFormData({ ...formData, country: country.dial_code }); // For API
    setFormData2({ country }); // For UI display
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="production-dialer">
      <div className="card-wrapper stitch-dialer h-[550px] md:w-[500px] w-[350px]">
                <div
                  className="py-3 px-5  gap-2  bg-[#070707]  transition-all rounded-full card-content flex items-center justify-center text-xs"
                >
                  <div className="m-8 my-14 w-full ">
                    <div className="mb-8">
                      {currentStep === 1 && (
                        <h1 className="mb-4 text-xl font-semibold text-center text-white">
                          Initiate Your First Call
                        </h1>
                      )}
                      {currentStep === 2 && (
                        <h1 className="mb-4 text-xl font-semibold text-center text-white">
                          First Call Initiated ...
                        </h1>
                      )}
                    </div>
                    <ul className="steps mt-5 flex justify-center space-x-4">
                      <li
                        className={`step ${currentStep >= 1 ? "step-primary" : "step-secondary"
                          }`}
                      ></li>
                      <li
                        className={`step ${currentStep >= 2 ? "step-primary" : ""
                          }`}
                      ></li>
                    </ul>
                    <AnimatePresence>
                      {currentStep === 1 && (
                        <motion.div
                          key="step1"
                          animate={{ opacity: 1, x: 0 }}
                          exit={{ opacity: 0, x: -50 }}
                          transition={{ duration: 0.2 }}
                          className="mt-5"
                        >

                          <div className="mt-5">
                            <label className="flex w-full items-center gap-3 rounded-md border border-gray-700 bg-black px-4 py-2">
                              <div ref={dropdownRef} className="relative inline-block ">
                                <button
                                  onClick={() => setIsOpen(!isOpen)}
                                  className=" bg-transparent text-white  py-2 rounded flex justify-between items-center"
                                >
                                  {formData2.country ? (
                                    <div className="flex items-center gap-2">
                                      <img src={formData2.country.icon} alt="" className="h-4 w-4" />
                                      <span>{formData2.country.dial_code}</span>
                                      <span>▾</span>
                                    </div>
                                  ) : (
                                    <div> Select country
                                      <span>▾</span>
                                    </div>

                                  )}

                                </button>

                                {isOpen && (
                                  <ul className="absolute z-10 bg-black shadow-lg w-64  max-h-40 overflow-y-auto mt-2 rounded">
                                    {countryData.map((country) => (
                                      <li
                                        key={country.code}
                                        onClick={() => handleSelect(country)}
                                        className="cursor-pointer hover:bg-gray-800 text-white px-4 py-2 flex items-center gap-2"
                                      >
                                        <img src={country.icon} alt="" className="h-4 w-4" />
                                        <span>{country.name} ({country.dial_code})</span>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                              <input
                                type="number"
                                placeholder="Phone Number"
                                className=" bg-transparent text-md border-none text-white placeholder-gray-400 focus:outline-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                                value={formData.phoneNumber}
                                required
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    phoneNumber: e.target.value,
                                  })
                                }
                              />
                            </label>
                          </div>

                        </motion.div>
                      )}

                      {currentStep === 2 && (
                        <motion.h2
                          key="step2"
                          initial={{ opacity: 0, x: 50 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ duration: 0.2, delay: 0.2 }}
                          className="text-2xl mt-5 font-bold text-center text-white"
                        >
                          <h1 className="text-sm font-medium text-gray-200 ">
                            Check Your phone
                          </h1>
                          <div className="flex justify-center mt-10">
                            <motion.div
                              animate={{
                                rotate: [0, -0.5, 0.5, -0.5, 0.5, 0],
                              }}
                              transition={{
                                duration: 0.3,
                                repeat: Infinity,
                                repeatType: "loop",
                              }}
                            >
                              <RingingPhone className="" />
                            </motion.div>
                          </div>

                          {/* <div className="flex justify-center mt-4 rotate-12">
                    <RingingPhone  className=""/>
                  </div> */}
                        </motion.h2>
                      )}
                    </AnimatePresence>

                    <div className="gap-3 mt-6 flex flex-col justify-center items-center">
                      {/* <button
                            className="p-3 bg-[#040115] hover:bg-white text-white hover:text-black transition-all border rounded-2xl w-full font-semibold"
                            onClick={handleCloseModal}
                          >
                            Close
                          </button> */}
                      {/* {currentStep === 1 && (
  <div className="w-full">
    <label className="text-white font-medium mb-2 block">
      Select Bot to Test
    </label>
    <select
      value={selectedBot}
      onChange={(e) => setSelectedBot(e.target.value)}
      className="select w-full bg-black text-white border border-gray-600 rounded-md p-2"
      required
    >
      <option value="" disabled>Select a bot</option>
      <option value="real_estate">Real Estate</option>
      <option value="leads_qualification">Leads Qualification</option>
      <option value="appointment_scheduling">Appointment Scheduling</option>
      <option value="customer_care">Customer Care</option>
    </select>
  </div>
)} */}
                      {currentStep === 1 && (
                        <div className="w-full text-white mb-4">
                          <label className="block text-center text-white font-medium mb-4">
                            Select Assistant
                          </label>
                          <div className="grid grid-cols-2 gap-4">
                            <label className="flex items-center gap-2 bg-black p-3 rounded-lg border border-gray-700 cursor-pointer">
                              <input
                                type="radio"
                                name="bot"
                                value="real_estate"
                                checked={selectedBot === "real_estate"}
                                onChange={(e) => setSelectedBot(e.target.value)}
                                className="radio radio-primary"
                              />
                              <span>Real Estate</span>
                            </label>

                            <label className="flex items-center gap-2 bg-black p-3 rounded-lg border border-gray-700 cursor-pointer">
                              <input
                                type="radio"
                                name="bot"
                                value="leads_qualification"
                                checked={selectedBot === "leads_qualification"}
                                onChange={(e) => setSelectedBot(e.target.value)}
                                className="radio radio-primary"
                              />
                              <span>Leads Qualification</span>
                            </label>

                            <label className="flex items-center gap-2 bg-black p-3 rounded-lg border border-gray-700 cursor-pointer">
                              <input
                                type="radio"
                                name="bot"
                                value="appointment_scheduling"
                                checked={
                                  selectedBot === "appointment_scheduling"
                                }
                                onChange={(e) => setSelectedBot(e.target.value)}
                                className="radio radio-primary"
                              />
                              <span>Courier Services</span>
                            </label>

                            <label className="flex items-center gap-2 bg-black p-3 rounded-lg border border-gray-700 cursor-pointer">
                              <input
                                type="radio"
                                name="bot"
                                value="customer_care"
                                checked={selectedBot === "customer_care"}
                                onChange={(e) => setSelectedBot(e.target.value)}
                                className="radio radio-primary"
                              />
                              <span>Customer Care</span>
                            </label>
                          </div>
                        </div>
                      )}

                      {currentStep === 1 && (
                        <ReCAPTCHA
                          style={{ transform: "scale(0.8)" }}
                          //  size="compact"
                          sitekey="6LdXdJksAAAAANVIODw3v5zqGcSECZK_uKh3KOg0" //local
                          // sitekey="6LfWd9YqAAAAALnmS2axobeF4YswIHov6M5oy9vF" //live

                          // sitekey="6Lelp-MqAAAAALuXsMJJ7pMucn1WD_T1dvrwpamC" //Domain
                          // sitekey="6LciDtUqAAAAAP6jZrY1pHJNL_s9RjevEq8vt1vJ"  ngrok
                          onChange={(val) => setCapValue(val)}
                        />
                      )}
                      {errorMessage && (
                        <p className="text-red-500 text-center mt-2">
                          {errorMessage}
                        </p>
                      )}
                      {currentStep === 1 && (
                        <button
                          className="p-3 bg-[#8B4AFA] hover:bg-[#5f32ad] transition-all rounded-2xl text-white w-full font-semibold disabled:hover:bg-[#8B4AFA] disabled:cursor-not-allowed"
                          onClick={handleApiSubmit}
                          disabled={!capValue}
                        >
                          Make Call
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
    </div>
  );
};
